export const SPOTLIGHT_COLORS = {
	scrim: "rgba(18, 36, 27, 0.74)",
	cream: "#fefde2",
	creamDeep: "#f3f1c9",
	green: "#4c956c",
	greenDark: "#2c6e49",
	greenLight: "#d7ebdf",
	orange: "#d68c45",
	text: "#34423a",
	mutedText: "#6b7a70",
	white: "#ffffff",
};

export const SPOTLIGHT_FONT_FAMILY = "Bodoni72Smallcaps, Georgia, serif";

export const SPOTLIGHT_Z_INDEX = 2147483000;
export const SPOTLIGHT_TRANSITION_MS = 320;
export const SPOTLIGHT_HOLE_PADDING = 8;
export const SPOTLIGHT_VIEWPORT_MARGIN = 12;
export const SPOTLIGHT_COMPACT_BREAKPOINT = 640;

const STYLE_ELEMENT_ID = "spotlight-tutorial-keyframes";

const KEYFRAMES_CSS = `
@keyframes spotlightCardIn {
	from { opacity: 0; transform: translateY(8px); }
	to { opacity: 1; transform: translateY(0); }
}
@keyframes spotlightFadeIn {
	from { opacity: 0; }
	to { opacity: 1; }
}
@keyframes spotlightRingPulse {
	0%, 100% { box-shadow: 0 0 0 3px ${SPOTLIGHT_COLORS.cream}, 0 0 0 7px rgba(76, 149, 108, 0.55), 0 0 24px 6px rgba(76, 149, 108, 0.35); }
	50% { box-shadow: 0 0 0 3px ${SPOTLIGHT_COLORS.cream}, 0 0 0 10px rgba(214, 140, 69, 0.55), 0 0 30px 10px rgba(214, 140, 69, 0.3); }
}
@keyframes spotlightDotPulse {
	0%, 100% { transform: scale(1); opacity: 1; }
	50% { transform: scale(1.5); opacity: 0.6; }
}
.spotlight-button { cursor: pointer; transition: filter 160ms ease, transform 160ms ease, background-color 160ms ease; }
.spotlight-button:hover:not(:disabled) { filter: brightness(1.07); }
.spotlight-button:active:not(:disabled) { transform: scale(0.98); }
.spotlight-button:focus-visible { outline: 2px solid ${SPOTLIGHT_COLORS.orange}; outline-offset: 2px; }
.spotlight-button:disabled { cursor: not-allowed; }
.spotlight-link { cursor: pointer; transition: color 160ms ease; }
.spotlight-link:hover { color: ${SPOTLIGHT_COLORS.greenDark}; }
.spotlight-link:focus-visible { outline: 2px solid ${SPOTLIGHT_COLORS.orange}; outline-offset: 2px; border-radius: 4px; }
@media (prefers-reduced-motion: reduce) {
	[data-spotlight-animated] { animation: none !important; transition: none !important; }
}
`;

/** Injects the tutorial keyframes once. Safe to call repeatedly. */
export const ensureSpotlightStyles = () => {
	if (typeof document === "undefined" || document.getElementById(STYLE_ELEMENT_ID)) return;
	const styleElement = document.createElement("style");
	styleElement.id = STYLE_ELEMENT_ID;
	styleElement.textContent = KEYFRAMES_CSS;
	document.head.appendChild(styleElement);
};
